import React from 'react';

// Use optimized smaller logo images for better performance
export function LogoIcon({ className = "w-8 h-8", size = "medium" }) {
  // Use appropriately sized image based on display size
  const src = size === "small" ? "/logo-64.webp" : "/logo-128.webp";
  return (
    <img 
      src={src} 
      alt="Living Geeta" 
      className={`${className} rounded-full object-cover`}
      width={size === "small" ? 16 : 32}
      height={size === "small" ? 16 : 32}
      loading="eager"
      decoding="async"
    />
  );
}

export function LogoFull({ className = "", testId = "logo-link" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid={testId}>
      <LogoIcon size="medium" />
      <span className="font-['Playfair_Display'] text-xl font-semibold text-foreground">Living Geeta</span>
    </div>
  );
}

export function LogoSmall() {
  return (
    <div className="flex items-center gap-2">
      <LogoIcon className="w-4 h-4" size="small" />
      <span className="font-['Playfair_Display'] text-sm text-foreground">Living Geeta</span>
    </div>
  );
}
